import { FiscalpopRequestOptions, getJson, postJson } from './fiscalpop.base';

export interface ProductoServicioResult {
    clave: string;
    descripcion?: string;
    nombre?: string;
}

export interface ClaveUnidadResult {
    clave: string;
    nombre: string;
}

export interface SatLookupBody {
    clave: string;
    compare?: string;
}

export const searchProductosServicios = (
    authToken: string,
    body: SatLookupBody,
    options: FiscalpopRequestOptions = {},
): Promise<ProductoServicioResult[]> => {
    return postJson<ProductoServicioResult[]>(`/sat/productosServicios/${authToken}`, body, options);
};

export const searchClaveUnidades = (
    authToken: string,
    body: SatLookupBody,
    options: FiscalpopRequestOptions = {},
): Promise<ClaveUnidadResult[]> => {
    return postJson<ClaveUnidadResult[]>(`/sat/claveUnidades/${authToken}`, body, options);
};

export interface UsoCfdiOption {
    key: string;
    label: string;
}

export const getUsoCfdi = (
    authToken: string,
    options: FiscalpopRequestOptions = {},
): Promise<UsoCfdiOption[]> => {
    return getJson<UsoCfdiOption[]>(`/sat/usoCfdi/${authToken}`, undefined, options);
};

export interface PayTypeOption {
    key: string;
    label: string;
}

export const getPayTypes = (
    authToken: string,
    options: FiscalpopRequestOptions = {},
): Promise<PayTypeOption[]> => {
    return getJson<PayTypeOption[]>(`/sat/payTypes/${authToken}`, undefined, options);
};
